import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import store from "@/store";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import { MobileDefaultTheme, DesktopDefaultTheme } from ".";
import { baseHeader, sideMenu, fullLoading } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'default',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();

const menuList = computed(() => [
  {
    icon: "change",
    label: t("common.labels.change_account"),
    url: "/accounts",
    active: true,
  },
  {
    icon: "plans",
    label: t("common.labels.plans"),
    url: "/plans",
    active: true,
  },
]);

return (_ctx: any,_cache: any) => {
  return (_ctx.$store.getters.mobile)
    ? (_openBlock(), _createBlock(_unref(MobileDefaultTheme), {
        key: 0,
        "menu-list": menuList.value
      }, {
        main: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["menu-list"]))
    : (_openBlock(), _createBlock(_unref(DesktopDefaultTheme), {
        key: 1,
        "menu-list": menuList.value
      }, {
        main: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["menu-list"]))
}
}

})